export enum SessionStatus {
  PLANNED = 'PLANNED',

  OPEN = 'OPEN',

  ALERT = 'ALERT',

  CLOSED = 'CLOSED',
}
